export const mapApiWeekToWeek = (
  apiWeek: number,
): { week: number; year: number } | undefined => {
  const str = apiWeek.toString();
  if (str.length !== 6) {
    return;
  }
  return { year: Number(str.slice(0, 4)), week: Number(str.slice(4, 6)) };
};
